import { STATUS_PENDING_FOR_START } from 'scenes/SmartRules/constants';

export const useInspection = ({ data }) => {
  return data
    ? !data.isFailed &&
        data.status === STATUS_PENDING_FOR_START &&
        !data.isStartApprovalSent
    : false;
};
